export default {
  form: {
    tax_id: {
      label: 'Skattenummer',
      placeholder: 'Indtast skattenummer',
    },
    has_vat: {
      label: 'Er din virksomhed momsregistreret?',
    },
    vat_id: {
      label: 'Moms',
      placeholder: 'Moms',
      tooltip: 'Et momsnummer (CVR) er et unikt skattenummer, der identificerer din virksomhed',
    },
    tax_percentage: {
      label: 'Skatteprocent',
      placeholder: 'Skatteprocent',
    },
    has_dedicated_products_tax: {
      label: 'Skatteprocenten varierer afhængigt af produktet',
    },
  },
  buttons: {
    next: 'Næste',
    back: 'Tilbage',
    skip: 'Spring over',
  },
};
